import { useEffect, useState } from "react";
import { Buildings, Check, CaretDown } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { api, fmtErr } from "../lib/api";
import { toastErr } from "../lib/toast";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export default function OrgSwitcher() {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user?.is_superadmin) return;
    api.get("/superadmin/orgs").then(({ data }) => setOrgs(data)).catch(() => {});
  }, [user?.is_superadmin, user?.org_id]);

  if (!user?.is_superadmin) return null;

  const switchTo = async (id) => {
    setBusy(true);
    try {
      await api.post("/superadmin/active-org", { org_id: id });
      window.location.href = "/dashboard";
    } catch (e) {
      toastErr(fmtErr(e));
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="org-switcher-trigger" disabled={busy}
          className="flex items-center gap-2 px-2.5 py-1.5 rounded-sm text-xs font-medium border border-[var(--c-accent)]/50 bg-[var(--c-accent)]/10 text-[var(--c-text)] hover:bg-[var(--c-accent)]/20 transition-colors duration-150 max-w-[260px]">
          <Buildings size={14} weight="fill" className="text-[var(--c-accent)] shrink-0" />
          <span className="truncate">{user?.org?.name || "Organization"}</span>
          <span className="hidden md:inline text-[9px] font-mono tracking-widest uppercase text-[var(--c-accent)]">God</span>
          <CaretDown size={11} className="text-[var(--c-muted)] shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="org-switcher-menu"
        className="bg-[var(--c-surface)] border-[var(--c-border)] w-80 max-h-[70vh] overflow-y-auto">
        <div className="px-3 py-2 text-[10px] font-mono tracking-widest uppercase text-[var(--c-muted)] border-b border-[var(--c-border)]">
          Platform superadmin · {orgs.length} organization{orgs.length === 1 ? "" : "s"}
        </div>
        {orgs.map((o) => (
          <DropdownMenuItem key={o.id} data-testid={`org-option-${o.id}`} onClick={() => switchTo(o.id)}
            className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)] focus:text-[var(--c-text)] cursor-pointer flex items-start gap-2 py-2">
            <Check size={13} className={`mt-0.5 shrink-0 ${o.active ? "text-[var(--c-accent)]" : "opacity-0"}`} />
            <span className="min-w-0">
              <span className="block text-xs font-medium truncate">{o.name}</span>
              <span className="block text-[10px] text-[var(--c-muted)] font-mono">
                {o.users} user{o.users === 1 ? "" : "s"} · {o.projects} project{o.projects === 1 ? "" : "s"}
              </span>
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
